import { render, staticRenderFns } from "./GetDashboardRegulatoryCompliance.vue?vue&type=template&id=fecbb1b6&"
import script from "./GetDashboardRegulatoryCompliance.vue?vue&type=script&lang=js&"
export * from "./GetDashboardRegulatoryCompliance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports